import {Suspense, useState} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import 'react-toastify/dist/ReactToastify.css'
import {ToastContainer, toast, Zoom} from 'react-toastify'
import AppContext from './AppContext'
// import LoadingIndicator from './modules/component/loading/LoadingIndicator'
import { OctLayoutProvider } from '@oceantech/oceantech-ui';

const App = () => {
  const [pageLoading, setPageLoading] = useState<boolean>(false);
  return (
		<AppContext.Provider value={{ pageLoading, setPageLoading }}>
			{/* <LoadingIndicator show={pageLoading} /> */}
			<Suspense fallback={<LayoutSplashScreen />}>
				<I18nProvider>
                    <OctLayoutProvider>
                        <AuthInit>
                            <Outlet />
                            <MasterInit />
                        </AuthInit>
                    </OctLayoutProvider>
					<ToastContainer
						autoClose={3000}
						position={'top-right'}
						transition={Zoom}
						theme="colored"
						pauseOnHover={false}
					/>
				</I18nProvider>
			</Suspense>
		</AppContext.Provider>
  );
}

export {App}
